import { AfterViewInit, Component, ElementRef, OnInit, Optional, Type, ViewChild } from '@angular/core';
import { NbDialogRef, NbMenuService, NbDialogService } from '@nebular/theme';
import { HomeInputGridComponent } from '../home-input-grid/home-input-grid.component';
import { RendererType } from '@urbannex/storethemes';
import { FeaturesInputDialogComponent } from './features-input-dialog/features-input-dialog.component';

@Component({
  selector: 'ngx-home-input-features',
  templateUrl: './home-input-features.component.html',
  styleUrls: ['./home-input-features.component.scss']
})
export class HomeInputFeaturesComponent implements OnInit, AfterViewInit{
  activeInputMenuItem:string;
  title:string;
  collapsed:boolean = true;

  @ViewChild('expandable',{read:ElementRef}) expandable:ElementRef<HTMLElement>
  
  constructor(
    @Optional() protected ref: NbDialogRef<HomeInputGridComponent>,
    private menuService:NbMenuService,
    private el:ElementRef<HTMLElement>,
    private dialogService: NbDialogService
    ) { }
  
  ngOnInit(): void {
    this.menuService.onItemClick().subscribe(menuBag =>{
      let selectedItem = menuBag.item;
      if(selectedItem != undefined){
        this.activeInputMenuItem = selectedItem.title;
      }
    })
  }

    /* ngOnInit(): void {
      this.menuService.onItemClick().subscribe(menuBag =>{
        let selectedItem = menuBag.item;
        if(selectedItem != undefined){
          this.activeInputMenuItem = selectedItem.title;
        }
      })
    } */
  
    ngAfterViewInit():void{
    const overlayPane = this.el.nativeElement.parentElement.parentElement;
    const overlayWrapper = this.el.nativeElement.parentElement.parentElement.parentElement;
    setTimeout(() => {
      overlayWrapper.style.left ="0px";
      overlayWrapper.style.justifyContent = "flex-end";
      overlayWrapper.style.right = "16px";
      //overlayPane.style.width = "256px";
      overlayPane.style.marginRight = "16px";
      overlayPane.style.marginTop = "18px";
      overlayPane.style.display = "block";
    }, 1);


    //return el.parentElement.parentElement.parentElement.parentElement;
  }

  toggleContainer(){
    this.expandable.nativeElement.classList.toggle("collapsed");
  }

  createGrid(numberOfCells:number){
    let component:Type<any> = FeaturesInputDialogComponent;
    let layoutClass = "grid-"+numberOfCells;

    console.log(layoutClass)

    this.dialogService.open(component, {
      context:{
        rendererType:RendererType.STOREFEATURES,
        layoutClass:layoutClass,
        title:"Adding new section with grid layout"
      }
    }).onClose.subscribe(() => {
      console.log("closing")
      /* this.previewEditStoreService.selectedPage$.subscribe((page:Page) => {
        console.log(page);
        if(page != null && page != undefined){
          this.communicator.sendFromParent({id:"selectedPage",data:page});
        }
        
      }) */
    })
    this.ref.close();
  }

  close(e){
    this.ref.close();
  }

}
